import * as THREE from "three";

export function domRectToWorld(rect: DOMRect, camera: THREE.PerspectiveCamera, rendererWidth: number, rendererHeight: number): { x: number; y: number; width: number; height: number } {
    const fovRad = (camera.fov * Math.PI) / 180;
    const worldHeight = 2 * Math.tan(fovRad / 2) * camera.position.z;
    const worldWidth = worldHeight * camera.aspect;

    const pxToWorldX = worldWidth / rendererWidth;
    const pxToWorldY = worldHeight / rendererHeight;

    const centerX = rect.left + rect.width / 2;
    const centerY = rect.top + rect.height / 2;

    const x = centerX * pxToWorldX - worldWidth / 2;
    const y = -(centerY * pxToWorldY) + worldHeight / 2;

    return {
        x,
        y,
        width: rect.width * pxToWorldX,
        height: rect.height * pxToWorldY,
    };
}
